import { useWorkflows, workflowSelector } from '@/store/workflows';
import { NodeShell } from '../NodeShell';
import type { NodeProps } from '@xyflow/react';

export function SpikeNode({ data }: NodeProps & { data: { workflowId: string } }) {
  const wf = useWorkflows(workflowSelector(data.workflowId));
  if (!wf) return null;
  return (
    <NodeShell title="Chat Spike" state={wf.states.spike} width={180}>
      <div className="text-[11px] text-ink-500 leading-relaxed">
        recording 5s rollback while chat density above baseline.
      </div>
    </NodeShell>
  );
}
